import { createEventFactory } from '@cp/shared/tracking';
import { ClientType } from '@common/model/client/clientType';
import { CatalogViewMode } from '../model';

export const CatalogEvents = {
  ViewModeChange: createEventFactory<CatalogViewMode>({
    subject: 'catalog',
    object: 'view',
    action: 'change',
    goalId: 'nazhatie_na_knopku_smotret_na_karte_v_filtre_listinga',
    goalName: 'Нажатие на кнопку "Смотреть на карте" в фильтре листинга',
  }),
  SortingChange: createEventFactory<{ 'Вариант': string; 'Категория пользователя'?: string }, { clientType?: ClientType; sort: string }>(
    {
      subject: 'catalog',
      object: 'sorting',
      action: 'change',
      goalId: 'vybor_sposoba_sortirovki',
      goalName: 'Выбор способа сортировки',
    },
    ({ sort }) => ({ 'Вариант': sort }),
  ),
  FilterCityChange: createEventFactory({
    subject: 'catalog-filter',
    object: 'city',
    action: 'change',
    goalId: 'smena_goroda_v_filtre_listinga',
    goalName: 'Смена города в фильтре листинга',
  }),
  FilterDateChange: createEventFactory({
    subject: 'catalog-filter',
    object: 'date',
    action: 'change',
    goalName: 'Выбор даты заказа в фильтре листинга',
    goalId: 'vybor_daty_zakaza_v_filtre_listinga',
  }),
  FilterTimeChange: createEventFactory({
    subject: 'catalog-filter',
    object: 'time',
    action: 'change',
    goalId: 'vybor_vremeni_zakaza_v_filtre_listinga',
    goalName: 'Выбор времени заказа в фильтре листинга',
  }),
  FilterShowAvailable: createEventFactory({
    subject: 'catalog-filter',
    object: 'available',
    action: 'change',
    goalName: 'Выбор селектора "Показать только доступных репититоров" в фильтре листинга',
    goalId: 'vybor_selektora_pokazat_tolko_dostupnyh_repititorov_v_filtre_listinga',
  }),
  FilterPriceChange: createEventFactory({
    subject: 'catalog-filter',
    object: 'price',
    action: 'change',
    goalId: 'vybor_filra_stoimosti_v_listinga',
    goalName: 'Выбор фильра стоимости в листинга',
  }),
  FilterOpen: createEventFactory({ subject: 'catalog-filter', action: 'open' }),
  ItemClick: createEventFactory({
    subject: 'catalog',
    object: 'item',
    action: 'click',
    goalId: 'vybor_ob"yavleniya_v_listinge',
    goalName: 'Выбор объявления в листинге',
  }),
  ItemLike: createEventFactory({
    subject: 'catalog',
    object: 'item',
    action: 'like',
    goalId: 'nazhatie_knopki_dobavit_v_izbrannoe',
    goalName: 'Нажатие кнопки "Добавить в избранное"',
  }),
  ItemInvite: createEventFactory({
    subject: 'catalog',
    object: 'item',
    action: 'invite',
    goalId: 'nazhatie_knopki_otpravit_priglashenie_',
    goalName: 'Нажатие кнопки "Отправить приглашение" ',
  }),
  ItemResponse: createEventFactory({
    subject: 'catalog',
    object: 'item',
    action: 'response',
    goalId: 'nazhatie_na_knopku_ya_mogu_v_ob"yavlenii',
    goalName: 'Нажатие на кнопку "Я могу" в объявлении',
  }),
  ItemQuestion: createEventFactory({
    subject: 'catalog',
    object: 'question',
    action: 'click',
    goalId: 'nazhatie_na_knopku_zadat_vopros_v_ob"yavlenii',
    goalName: 'Нажатие на кнопку "Задать вопрос" в объявлении',
  }),
} as const;
